import han from '../svg/icon/hund-han.svg';
import teve from '../svg/icon/hund-teve.svg';
import acd from '../svg/icon/arrow-dogweb-down.svg';
import acdw from '../svg/icon/arrow-dogweb-down-white.svg';
import tree from '../svg/icon/tree.svg';
import treeWt from '../svg/icon/tree-wt.svg';
import arb from '../svg/icon/arrow-right-black.svg';
import arw from '../svg/icon/arrow-right-white.svg';
import scoreWt from '../svg/icon/score-wt.svg';
import score from '../svg/icon/score.svg';
import document from '../svg/icon/document.svg';
import bookmark from '../svg/icon/bookmark.svg';
import fav from '../svg/icon/favourite.svg';
import favHollow from '../svg/icon/favouriteHollow.svg';
import mentalRed from '../svg/icon/mental-red.svg';
import mentalBlue from '../svg/icon/mental-blue.svg';
import mentalGreen from '../svg/icon/mental-green.svg';
import search from '../svg/icon/search.svg';
import help from '../svg/icon/help.svg';
import signout from '../svg/icon/signout.svg';
import cam from '../svg/icon/cam.svg';
import dod from '../svg/icon/dod.svg';
import logout from '../svg/icon/logout.svg';
import printer from '../svg/icon/printer.svg';
import slet from '../svg/icon/slet.svg';

function icons() {
  return {
    han,
    teve,
    acd,
    acdw,
    tree,
    treeWt,
    arw,
    arb,
    scoreWt,
    document,
    fav,
    favHollow,
    bookmark,
    score,
    mentalRed,
    mentalBlue,
    mentalGreen,
    search,
    help,
    signout,
    cam,
    dod,
    logout,
    printer,
    slet

  }
}

export default (icons());